// extracted by mini-css-extract-plugin
export default {"root":"classes_root__fjTEd","button-view-more":"classes_button-view-more__V4JYC"};